@if (_spinnerService.isLoading | async) {
  <mat-progress-spinner
    class="app-spinner"
    [mode]="spinnerMode"
    [strokeWidth]="5"
    [diameter]="80"
  />
}
<router-outlet />
